<template>
  <BaseAutoCompleteWithSingleSelectedItem
    v-model="modelValue"
    label="車番"
    itemName="number_plate"
    :items="filteredByDepartment"
    :management-office="managementOffice"
    :operation-offices="props.operationOffices"
    :error-messages="errorMessages"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getVehicleResponse from '@/types/responses/getVehicle';
import getDepartmentResponse from '@/types/responses/getDepartment';
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';

const props = defineProps<{
  modelValue: getVehicleResponse | undefined | null;
  selectedDepartment: getDepartmentResponse | null
  managementOffice?: getManagementOffice;
  operationOffices?: getOperationOffice[];
  errorMessages?: string[];
  requestParams?: any;
  filterAction?: (items: getVehicleResponse[]) => getVehicleResponse[];
}>();

const emit = defineEmits(['update:modelValue']);

const items = ref<ItemType[]>([]);

type ItemType = {
  number_plate: string;
  managementOfficeId: number;
  managementOfficeType: string;
  operationOfficeId: number;
  digital_tacograph: number;
  id: number;
};

onMounted(() => {
  Api()
    .autoComplete.vehicles(props.requestParams)
    .then((data) => {
      if (props?.filterAction) data = props?.filterAction(data)

      items.value = data.map((item: getVehicleResponse) => {
        return {
          number_plate: item.number_plate,
          managementOfficeId: item.management_officeable_id,
          managementOfficeType: item.management_officeable_type,
          operationOfficeId: item.operation_office_id,
          digital_tacograph: item.digital_tacograph,
          id: item.id,
          department_id: item.department_id,
        };
      });
    });
});

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const filteredByDepartment = computed(() => {
  if (!props.selectedDepartment) return items.value
  return items.value.filter(item => item.department_id === props.selectedDepartment.id)
})
</script>
